import React from 'react'
import classNames from 'classnames'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { Container } from 'react-bootstrap'

import { getOffice } from '../../../redux/slices/OfficeListSlice'

import styles from './SixthBlock.module.scss'
import logo from '../../../assets/img/centrum-logo.png'
import image from '../../../assets/img/ManagementBlock/image.png'
import instagramSvg from '../../../assets/img/FooterBlock/instagram.svg'
import facebookSvg from '../../../assets/img/FooterBlock/facebook.svg'
import linkedinSvg from '../../../assets/img/FooterBlock/linkedin.svg'

const SixthBlock = () => {
	const { t } = useTranslation()
	const { officeList } = useSelector(state => state.officeList)
	const { language } = useSelector(state => state.LangSlice)

	const dispatch = useDispatch()

	React.useEffect(() => {
		dispatch(getOffice())
	}, [])

	const sortedOffice = [...officeList].sort((first, last) => {
		return first.id - last.id
	})

	return (
		<div className={styles.root}>
			<div className={styles.footer}>
				<div className={styles.overlay}>
					<img src={image} alt='' width={250} />
				</div>
				<Container className={styles.container}>
					<div>
						<div className={styles.gridBlock}>
							<div className={styles.infoBlock}>
								<div className={classNames('mb-2', styles.logoBlock)}>
									<img src={logo} alt='' width={130} />
								</div>
								<div>
									<div>
										<p>{t('footerBlock.block.contacts')}:</p>
									</div>
									<div
										className={classNames(
											'd-flex align-items-center mt-1',
											styles.socialsBlock
										)}
									>
										<div>
											<img src={instagramSvg} alt='' width={35} />
										</div>
										<div className='ms-3'>
											<a
												href='https://www.facebook.com/profile.php?id=61555423164563'
												target='_blank'
											>
												<img src={facebookSvg} alt='' width={35} />
											</a>
										</div>
										<div className='ms-3'>
											<a
												href='https://uz.linkedin.com/company/centrum-logistics-group?trk=public_post_feed-actor-name'
												target='_blank'
											>
												<img src={linkedinSvg} alt='' width={35} />
											</a>
										</div>
									</div>
								</div>
							</div>
							{sortedOffice.map(val => {
								return (
									<div key={val.id} className={styles.infoBlock}>
										{language === 'en' ? (
											<p
												className={styles.titleBlock}
												dangerouslySetInnerHTML={{
													__html: val.address_en,
												}}
											/>
										) : (
											<p
												className={styles.titleBlock}
												dangerouslySetInnerHTML={{
													__html: val.address,
												}}
											/>
										)}
									</div>
								)
							})}
						</div>
						<div
							className={classNames(
								'd-flex justify-content-between mt-3',
								styles.flexBlock
							)}
						>
							<div>
								<p>{t('footerBlock.block5.title')} «Centrum Logistics Group»</p>
							</div>
							<div>
								<p>
									Copyright (c): Centrum Logistics Group. All rights reserved
								</p>
							</div>
						</div>
					</div>
				</Container>
			</div>
		</div>
	)
}

export default SixthBlock
